<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da tela -->
          <basic-toolbar :title="'Pesquisar Órgãos'"></basic-toolbar>

          <v-card-text>

            <!-- Mensagem informativa -->
            <v-layout row>
              <v-flex xs12>
                <v-alert
                  class="alerta"
                  color="#00796b"
                  type="info"
                  dense
                  outlined
                >
                  Para adicionar um órgão financiador, realize a pesquisa pelo nome ou sigla do órgão. Caso o órgão desejado não seja encontrado, 
                  clique no botão "CADASTRAR ÓRGÃO".
                </v-alert>
              </v-flex>
            </v-layout>

            <v-form v-model="formularioValido" ref="form">

              <v-container>

                <!-- Filtros para pesquisar órgãos -->
                <v-layout row wrap justify-space-between>

                  <v-flex xs6>
                    <v-radio-group v-model="tipoBusca" row>
                      <!-- Filtro por nome -->
                      <v-radio label="Nome" value="nome"></v-radio>
                      <!-- Filtro por sigla -->
                      <v-radio label="Sigla" value="sigla"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs9>
                    <!-- Nome -->
                    <v-text-field
                      v-show="tipoBusca==='nome'"
                      v-model="orgaoFinanciador.nome"
                      label='Nome'
                      @keyup.enter="pesquisaOrgaosFinanciadoresPorNome()"
                      >
                    </v-text-field>
                    <!-- Sigla -->
                    <v-text-field
                      v-show="tipoBusca!=='nome'"
                      v-model="orgaoFinanciador.sigla"
                      label='Sigla'
                      @keyup.enter="pesquisaOrgaosFinanciadoresPorSigla()"
                      >
                    </v-text-field>
                  </v-flex>

                  <!-- Botão "Pesquisar" -->
                  <v-flex xs3 style="padding-top:15px">
                    <!-- Pesquisar por nome -->
                    <v-btn v-if="tipoBusca==='nome'" color="primary" style="margin-left: 15px;" @click="pesquisaOrgaosFinanciadoresPorNome()">Pesquisar</v-btn>
                    <!-- Pesquisar por sigla -->
                    <v-btn v-else color="primary" style="margin-left: 15px;" @click="pesquisaOrgaosFinanciadoresPorSigla()">Pesquisar</v-btn>
                  </v-flex>

                </v-layout>

              </v-container>

            </v-form>

            <br><br>

            <v-divider></v-divider>

            <!-- Tabela com os órgãos financiadores -->
            <v-data-table
            :headers="headers"
            :items="listaOrgaos"
            :search="search"
            :no-data-text="'Nenhum órgão encontrado'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >

              <!-- Formata a sigla -->
              <template v-slot:item.sigla="props">{{ props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla }}</template>

              <!-- Adicionar órgão financiador -->
              <template v-slot:item.opcoes="props">
                
                <c-tooltip-btn
                  icon="add_box"
                  color="primary"
                  tooltip="Adicionar órgão financiador"
                  @click="toAdicionarOrgaoFinanciador(props.item.id)"
                ></c-tooltip-btn>

              </template>

              <!-- Número total de órgãos -->
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaOrgaos.length }} {{ listaOrgaos.length > 1 ? 'órgãos' : 'órgão' }}
              </template>

            </v-data-table>

            <br>

            <v-divider></v-divider>

            <v-card-actions>

              <!-- Botão "Cancelar" -->
              <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Botão "Cadastrar Órgão" -->
              <v-btn color="primary" @click="cadastrarOrgao()">Cadastrar Órgão</v-btn>

            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import TootipButton from '@/components/c-tooltip-btn'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa', 'projetoPesquisa'],
    data: () => ({
      tipoBusca: 'nome',
      orgaoFinanciador: {
        nome: '',
        sigla: ''
      },
      projetoPesquisa: {},
      listaOrgaos: [],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Nome', align: 'left', value: 'nome' },
        { text: 'Sigla', align: 'left', value: 'sigla' },
        { text: 'Opções', align: 'left', value: 'opcoes' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['administrador'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Pesquisa órgãos financiadores por nome.
      pesquisaOrgaosFinanciadoresPorNome () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando órgãos financiadores...' })
        projetos.getPesquisaOrgaosFinanciadoresPorNome(this.orgaoFinanciador.nome)
        .then(response => {
          this.listaOrgaos = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
          this.listaOrgaos = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando órgãos financiadores...' })
        })
      },

      // Pesquisa órgãos financiadores por sigla.
      pesquisaOrgaosFinanciadoresPorSigla () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando órgãos financiadores...' })
        projetos.getPesquisaOrgaosFinanciadoresPorSigla(this.orgaoFinanciador.sigla)
        .then(response => {
          this.listaOrgaos = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
          this.listaOrgaos = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando órgãos financiadores...' })
        })
      },

      // Cadastra um novo órgão financiador.
      cadastrarOrgao () {
        this.$router.push({ name: 'ProjetoPesquisaCadastrarOrgaoFinanciador', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
      },

      // Adiciona um órgão financiador ao projeto de pesquisa.
      toAdicionarOrgaoFinanciador: function (idOrgaoFinanciador) {
        this.$router.push({ name: 'ProjetoPesquisaAdicionarOrgaoFinanciador', params: {idProjetoPesquisa: this.idProjetoPesquisa, idOrgaoFinanciador: idOrgaoFinanciador} })
      },

      // Redireciona para a página anterior.
      cancelar: function () {
        this.$router.go(-1)
      }
    },
    mounted () {
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'c-tooltip-btn': TootipButton
    }
  }
</script>

<style scoped>

  .alerta {
    margin-top: 1.5em;
    margin-bottom: 2.0em;
  }

</style>

<style lang="css">
  .menu {
    display: block !important;
  }

  .center {
    text-align: center;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// pesquisar-orgao-financiador.vue?8dee0908